/*

THIS IS THE COMPONENT THAT WILL BE USED TO RENDER THE APP FOOTER

*/

import React from 'react';
import './AppFooter.css';
import Modal from './Modal.js';
import { Link, Box } from "@material-ui/core";
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import LanguageIcon from '@material-ui/icons/Language';

const AppFooter = ({ footerLinks, appConfigLoaded }) => {
  const frontConfig = useSelector(state => state.frontConfigReducer);
  const [open, setOpen] = React.useState(false);
  const [description, setDescription] = React.useState("");
  const [title, setTitle] = React.useState("");
  const { t, i18n } = useTranslation();

  const handleClickOpen = (title, description) => {
    setDescription(description);
    setTitle(title);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div className="AppFooter">
      {/*Still in development: hidden for release {
        appConfigLoaded ? 
        <Box display="flex" justifyContent="center" p={1}>
          <Box p={1} key='privacy_policy'>
            <Link href="#" className="FooterLink" key='privacy_policy' onClick={() => handleClickOpen("Privacy Policy", frontConfig.privacy_policy)}>
              {t("Privacy policy")}
            </Link>
          </Box>
          <Box p={1} key='refund_policy'>
            <Link href="#" className="FooterLink" key='refund_policy' onClick={() => handleClickOpen("Refund Policy", frontConfig.refund_policy)}>
              {t("Refund policy")}
            </Link>
          </Box>
          <Box p={1} key='terms_of_services'>
            <Link href="#" className="FooterLink" key='terms_of_services' onClick={() => handleClickOpen("Terms of Services", frontConfig.terms_of_services)}>
              {t("Term of Services")}
            </Link>
          </Box>
        </Box> : null
      }
      <Modal title={title} description={description} open={open} handleClose={handleClose} /> */}

    </div>
  )
}

export default AppFooter;

AppFooter.defaultProps = {
  footerLinks: [
    {
      code: "privacy_policy",
      title: "Privacy policy",
      description: "This is a privacy policy."
    },
    {
      code: "refund_policy",
      title: "Refund policy",
      description: "This is a refund policy."
    },
    {
      code: "terms_of_service",
      title: "Terms of service",
      description: "These are the terms of service"
    }
  ]
};

